<template lang="pug">
  v-flex(xs12 md12 lg12 class="initial-window-rpp")
    h2(class="omnesMedium rpp-title") ¿Qué deseas hacer?
    v-layout(row wrap)
      v-flex(xs1 sm1 :md4="availableForPrepaid" :lg4="availableForPrepaid" :md5="!availableForPrepaid" :lg5="!availableForPrepaid")
      v-flex(xs5 md2 lg2 class="main-icons" @click="showInformationLoans()")
        .wrapper
          img(:src="icons.prestamo" width="35%" alt="prestamos")
          p.omnesRegular Solicitar un préstamo
      v-flex(xs5 md2 lg2 class="main-icons prepago" @click="showInformationPrepaids()" v-if="availableForPrepaid")
        .wrapper
          img(:src="icons.prepago" width="36%" alt="prepagos")
          p.omnesRegular Prepagar un préstamo
      v-flex(xs1 sm1 :md4="availableForPrepaid" :lg4="availableForPrepaid" :md5="!availableForPrepaid" :lg5="!availableForPrepaid")
    //- Products for Loans
    v-dialog(v-model="dialogChooseLoans" max-width="700px")
      v-card#choose-product-loans
        v-card-title.px-0.pt-4
          h2.omnesSemibold.text-xs-center Elige uno de tus productos
        v-card-text
          v-layout.mt-3(row wrap)
            v-flex(xs12 sm12 md3 lg3)
            v-flex(xs12 sm12 md6 lg6)
              v-select(:items='items.products' label="PRODUCTO" required v-model='form.product' @change="changePolicyData")
            v-flex(xs12 sm12 md3 lg3)
          v-layout.mt-4(row wrap)
            v-flex(xs12 sm12 md3 lg3)
            v-flex(xs12 sm12 md6 lg6)
              v-select(:items='items.policiy' label="PÓLIZA" required v-model='form.policy')
            v-flex(xs12 sm12 md3 lg3)
          v-layout.mt-3(row wrap)
            v-flex(xs12 sm12 md3 lg3)
            v-flex.choosenBtn.text-xs-center(xs12 sm12 md6 lg6)
              v-btn.omnesMedium(v-if="!onEnterLoan" block @click.native="goToLoans" :disabled="!(form.product && form.policy)") Ingresar
              v-btn#btnLogin(v-else disabled type='button')
                span INGRESANDO
                //- pulse-loader(:loading="onEnterLoan" :color="color" :size="size")
            v-flex(xs12 sm12 md3 lg3)
    //- LOADER PROCESS
    v-dialog(v-model="validateLoader" persistent width="300")
      v-card(color="primary" dark="")
        v-card-text
          | Validando información...
          v-progress-linear.mb-0(indeterminate="" color="white")
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import axios from 'axios'
import Functionalities from '../../interfaces/functionalities'
import quoter from '../../interfaces/quoter'
import trackingMixin from '../../mixins/trackingMixin'

export default {
  mixins: [trackingMixin],
  data () {
    return {
      policyAvailableForLoan: [],
      availableForPrepaid: false,
      dialogChooseLoans: false,
      onEnterLoan: false,
      validateLoader: false,
      items: {
        products: [{value: null, text: 'Selecciona un producto'}],
        policiy: [{ value: null, text: 'Selecciona tu póliza' }]
      },
      form: {
        product: null,
        policy: null
      },
      icons: {
        prestamo: require('./../../assets/icons-prepagos/icon-solicita-prestamo.svg'),
        prepago: require('./../../assets/icons-prepagos/icon-prepagar-prestamo.svg')
      },
      loans: {
        bullet1: require('./../../assets/loans/bullet-1.svg'),
        bullet2: require('./../../assets/loans/bullet-2.svg'),
        bullet3: require('./../../assets/loans/bullet-3.svg')
      },
      amplitude: {
        events: {
          funcionalitySelected: 'Funcionalidad Seleccionada',
          loanIntention: 'Intención de Préstamo'
        },
        properties: {
          loans: 'Prestamos',
          prepaids: 'Prepagos'
        }
      }
    }
  },
  computed: {
    ...mapGetters('user', ['polizasInfo', 'userInfo', 'basicInfo', 'functionsRules'])
  },
  methods: {
    ...mapActions('user', ['getPrestamosActivos', 'getInformacionPrestamo', 'getEstadoPrestamo', 'setEstadoPrestamo']),
    showInformationPrepaids () {
      let self = this
      if (!Functionalities.isAvailable(Functionalities.rentas.PREPAGOS, self.functionsRules, self)) {
        return
      }
      // TRACK EVENT - AMPLITUDE
      this.$amplitude.getInstance()
        .logEvent(
          this.amplitude.events.funcionalitySelected,
          {
            'Funcionalidad': this.amplitude.properties.prepaids
          }
        )
      this.$router.push('/prepago')
    },
    showInformationLoans () {
      let self = this
      if (!Functionalities.isAvailable(Functionalities.rentas.PRESTAMOS, self.functionsRules, self)) {
        return
      }
      
      // Registrar evento GTM al hacer clic en "Solicitar un préstamo"
      this.$gtm.trackEvent({
        event: 'select_button',
        'Nombre Sección': 'Zona Segura',
        TipoElemento: 'Botón',
        TipoAccion: 'Préstamo operaciones - solicitar',
        CTA: 'Solicitar un préstamo'
      })
      
      let polizasAvaliable = null
      // eslint-disable-next-line no-unused-vars
      let finalPolizasAvaliable = []
      let axiosRequests = []
      self.validateLoader = true
      if (self.polizasInfo !== null) {
        polizasAvaliable = self.polizasInfo.filter(f => {
          return f.ramo === 'RRVV' && (f.codigoProducto === 'RPP' || f.codigoProducto === 'IFP') && parseInt(f.periodoGarantizado) > 0 && f.celular !== ''
        })
        if (polizasAvaliable.length > 0) {
          for (let i = 0; i < polizasAvaliable.length; i++) {
            axiosRequests.push(self.getInformacionPrestamo({poliza: polizasAvaliable[i].numeroPoliza, vista: 'Operations'}))
          }
          axios.all(axiosRequests).then(function (results) {
            self.validateLoader = false
            results.forEach(function (res) {
              if (res.data && (res.data.ingresoMensual > 1 || (res.data.devolucion.porcentaje && res.data.devolucionActual > res.data.devolucion.monto / 2))) {
                // Validando monto máximo del préstamo
                quoter.setInfoDataPolicy(res.data)
                let currency = (res.data.moneda.codigo === '001' || res.data.moneda.codigo === '013') ? 'S/' : '$'
                const minLoanAmount = (currency === 'S/') ? quoter.loanLimits.min.PEN : quoter.loanLimits.min.USD
                let minMaxLoan = quoter.calculateMaxMinLoan()
                
                if (minMaxLoan.max < minLoanAmount || minMaxLoan.max <= 0) {
                  return
                }

                //! OBTAIN GENERAL DATA FOR POLIZA
                let infoPoliza = self.polizasInfo.filter(f => { return f.numeroPoliza === res.data.numeroPoliza })[0]
                //! POPULATE DATA FOR POLIZA AVAILABLE
                self.policyAvailableForLoan.push({
                  numeroPoliza: infoPoliza.numeroPoliza,
                  producto: infoPoliza.producto,
                  codigoProducto: infoPoliza.codigoProducto,
                  ramo: infoPoliza.ramo,
                  periodoGarantizado: infoPoliza.periodoGarantizado,
                  celular: infoPoliza.celular,
                  ingresoMensual: res.data.ingresoMensual
                })
              }
            })
            if (self.policyAvailableForLoan.length > 0) {
              self.$gtm.trackEvent({ event: 'Elige tu producto' })
              self.dialogChooseLoans = true
              self.policyAvailableForLoan.map(product => {
                self.items.products.push({ value: product.codigoProducto, text: product.producto })
              })
            } else {
              self.$swal({
                title: 'Atención',
                text: 'Ya no puedes pedir más préstamos porque has llegado al límite de tu renta mensual. Si deseas más préstamos, puedes prepagarlos.',
                type: 'info',
                confirmButtonText: 'Entendido'
              }).then((result) => {
                self.$store.state.user.haveLoanRequested = null
              })
            }
          })
        } else {
          self.validateLoader = false
          self.$swal({
            title: 'Estimado Cliente',
            text: 'Le comunicamos que debe tener registrado su número de celular con nosotros. Por favor, comunicarse con Servicio de Atención al Cliente para registrar su número de celular.',
            type: 'info',
            confirmButtonText: 'Entendido'
          })
        }
      } else {
        self.validateLoader = false
        self.$swal({
          title: 'Estimado Cliente',
          text: 'Estamos validando su información. Puedes ingresar a Mis Seguros para ver el estado del proceso.',
          type: 'warning',
          confirmButtonText: 'Entendido'
        })
      }
    },
    changePolicyData () {
      if (this.form.product) {
        this.items.policiy = this.policyAvailableForLoan.filter(f => {
          return f.codigoProducto === this.form.product && f.ramo === 'RRVV' && parseInt(f.periodoGarantizado) > 0 && f.celular !== ''
        }).map(r => {
          return { value: r.numeroPoliza, text: r.numeroPoliza }
        })
      } else {
        this.items.policiy = []
      }
    },
    goToLoans () {
      let self = this
      
      // Registrar evento GTM al hacer clic en "Ingresar" del modal
      this.$gtm.trackEvent({
        event: 'select_button',
        'Nombre Sección': 'Zona Segura',
        TipoElemento: 'Botón',
        TipoAccion: 'Préstamo - elige tu producto - ingresar',
        CTA: 'Ingresar'
      })
      
      self.onEnterLoan = true
      self.getEstadoPrestamo({ codigoUsuario: self.userInfo.codigoUsuario }).then(res => {
        if (!res.data.procesandoPrestamo) {
          self.setEstadoPrestamo({ codigoUsuario: self.userInfo.codigoUsuario, flag: true })
            .then(res => {
              if (res.data.procesandoPrestamo !== 'already') {
                self.onEnterLoan = false
                localStorage.setItem('selPol', self.form.policy)
                // TRACK EVENT - GA
                self.$gtm.trackEvent({
                  event: 'Ingresar a prestamos',
                  producto_prestamo: self.form.product,
                  poliza: self.form.policy
                })
                // TRACK EVENT - AMPLITUDE
                this.$amplitude.getInstance()
                  .logEvent(
                    this.amplitude.events.funcionalitySelected,
                    {
                      'Funcionalidad': this.amplitude.properties.loans
                    }
                  )
                // TRACK EVENT - AMPLITUDE
                this.$amplitude.getInstance()
                  .logEvent(
                    this.amplitude.events.loanIntention,
                    {
                      'Producto': self.form.product,
                      'Poliza': self.form.policy,
                      'Tipo de intención': 'Préstamo RPP-IFP'
                    }
                  )
                self.$router.push('/prestamos/paso/cotizar')
              } else {
                self.onEnterLoan = false
                self.dialogChooseLoans = false
                self.trackValidationPopup('Tienes un prestamo en cotizacion')
                self.$swal({
                  title: 'Atención',
                  text: 'Tienes un préstamo en cotización. Si deseas empezar de nuevo, cierra sesión en todos los dispositivos y vuelve a intentarlo.',
                  type: 'error',
                  confirmButtonText: 'Entendido'
                }).then((result) => {
                  self.$store.state.user.haveLoanRequested = null
                })
              }
            })
        } else {
          self.onEnterLoan = false
          self.dialogChooseLoans = false
          self.trackValidationPopup('Tienes un prestamo en cotizacion')
          self.$swal({
            title: 'Atención',
            text: 'Tienes un préstamo en cotización. Si deseas empezar uno nuevo, cierra sesión en todos los dispositivos y vuelve a intentarlo.',
            type: 'error',
            confirmButtonText: 'Entendido'
          }).then((result) => {
            self.$store.state.user.haveLoanRequested = null
          })
        }
      })
    },
    goToPrepaids () {}
  },
  created () {},
  mounted () {
    const self = this
    this.getPrestamosActivos({ tipoDocumento: this.basicInfo.tipoDocumento === 'DNI' ? 'D' : 'C', numeroDocumento: this.basicInfo.numeroDocumento })
      .then((res) => {
        let prestamos = res.data.prestamos
        if (prestamos.length > 0) {
          this.availableForPrepaid = true
        }
      })
      .catch(() => {
        this.availableForPrepaid = false
      })

    self.$root.$emit('npsInactivity', {seccion: 'Préstamos', metadata: { productoConsultado: 'RRVV' }})
  }
}
</script>

<style>
h2.rpp-title {
  text-align: center;
  margin-top: 3em;
  margin-bottom: 2em;
  font-size: 24px;
}
.initial-window-rpp .main-icons {
  text-align: center;
}
.initial-window-rpp .main-icons p {
  font-size: 16px;
  margin-top: 8px;
}
.initial-window-rpp .main-icons .wrapper {
  cursor: pointer;
  border: 1px solid #DADBE2;
  border-radius: 5px;
  padding: 2em 0;
  margin: 0 4em;
}
.initial-window-rpp .main-icons .wrapper:hover { border: 1px solid var(--first-brand-color); }
.initial-window-rpp .main-icons.prepago img { margin: 10px 0; }

/* Small to large handset ----------- */
@media only screen and (max-width: 600px) {
  .initial-window-rpp .main-icons .wrapper {
    margin: 0 15px 0 0;
  }
  .initial-window-rpp .main-icons.prepago .wrapper {
    margin: 0 0 0 15px;
  }
  h2.rpp-title {
    font-size: 20px;
    margin-top: 6em;
  }
  .prepaid-process-main .prepaid-process-main-item .prepaid-process-step-3 article .layout button {
    width: 239px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Loans/Operations.vue